import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  min-width: 0;
`
export const TopInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top:20px;
  min-width: 0;

  @media screen and (max-width: 768px) {
    flex-wrap: wrap;

    > div {
      width: 100%;
      min-width: 0;
      flex-wrap: wrap;
      gap: 8px;
    }
  }
`
